module.exports = __webpack_public_path__ + "img/plan_oiseaux.53d68c9d.jpg";